import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Input } from '@/shared/ui/input';
import { ColumnFlexBox } from '@/shared/ui/layout';

export const CardContainer = styled(ColumnFlexBox)(({ theme }) => ({
  gap: theme.spacing(4),
  padding: theme.spacing(6, 0),
  borderRadius: theme.spacing(3),
}));

export const InfoItem = styled(ColumnFlexBox)(({ theme }) => ({
  width: '100%',
  gap: theme.spacing(3),
}));

export const HeaderText = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  fontWeight: 500,
  lineHeight: '120%',
  color: theme.customColors.black,
}));

export const ShopAddButton = styled(Button)(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  gap: '10px',
  padding: 0,
  borderRadius: 2,
  textTransform: 'none',
  border: 'none',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  '&:hover': {
    border: 'none',
    backgroundColor: 'transparent',
  },
}));

export const IconBox = styled(Box)(({ theme }) => ({
  width: 24,
  height: 24,
  minWidth: 24,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  lineHeight: 0,
  p: 0,
  backgroundColor: theme.customColors.primary100,
}));

export const ModalButton = styled(Button)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '100%',
  padding: theme.spacing(4, 0),
  borderRadius: theme.spacing(2),
  color: theme.palette.background.paper,
  backgroundColor: theme.customColors.primary100,
  '&:hover': {
    backgroundColor: theme.customColors.purple80,
  },
}));

export const CustomInput = styled(Input)(({ theme }) => ({
  '& .MuiInputLabel-root': { color: theme.customColors.black50 },
}));
